var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-container"},[_c('search',{on:{"childQuery":_vm.childQuery}}),_c('table-list',{ref:"tableList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }